import { defineMessages } from 'react-intl';
import type { SupportCaseCategoryEnum } from '@foundershub/api-client';

export const supportCategoryLabels = defineMessages<SupportCaseCategoryEnum>({
  'activating-azure': {
    defaultMessage: 'Activating Azure',
    description: 'activating azure support category label',
  },
  'domain-or-business-verification': {
    defaultMessage: 'Domain or Business Verification',
    description: 'domain or business verification category label',
  },
  'activating-non-azure-benefits': {
    defaultMessage: 'Activating non-Azure benefits',
    description: 'activating non azure benefits support category label',
  },
  'linkedin-login-help': {
    defaultMessage: "I'm having trouble accessing my LinkedIn account",
    description: 'linkedin login help support category label',
  },
  'microsoft-login-help': {
    defaultMessage: "I'm having trouble accessing my Microsoft account",
    description: 'microsoft login help support category label',
  },
  other: {
    defaultMessage: 'Other',
    description: 'other support category label',
  },
});

export const loggedInSupportCategoryLabelSlugs = [
  'activating-azure',
  'domain-or-business-verification',
  'activating-non-azure-benefits',
  'other',
];
